import React, { useState, useEffect } from "react";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import "../style/create_account_style.css";
import { Provider, useDispatch, useSelector } from "react-redux";
import { createAccountActions } from "../../../di/di";
import { userCreateAccount } from "../state/create_account_slice";
import { useNavigate } from 'react-router-dom';
import { OtpRoute } from "../../../../../core/routes/route_constants";
import { TermsOfServiceRoute, PrivacyPolicyRoute } from "../../../../../core/routes/route_constants";

const CreateAccountComp = () => {
  const Wave_1_2000 = "/images/wave_1_2000.png";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const nameErrorMessage = useSelector((state) => state.createAccount.nameErrorMessage);
  const emailErrorMessage = useSelector((state) => state.createAccount.emailErrorMessage);
  const passwordErrorMessage = useSelector((state) => state.createAccount.passwordErrorMessage);
  const confirmPasswordErrorMessage = useSelector((state) => state.createAccount.confirmPasswordErrorMessage);
  const registerErrorMessage = useSelector((state) => state.createAccount.registerErrorMessage);
  const isCreateOngoing = useSelector((state) => state.createAccount.isCreateOngoing);
  const goToOtp = useSelector((state) => state.createAccount.goToOtp);
  const email = useSelector((state) => state.createAccount.email);
  
  useEffect(() => {
    if (goToOtp === true) {
      navigate(OtpRoute + '?email=' + email);
    }
  }, [goToOtp]);

  useEffect(() => {
    return () => {
      dispatch(createAccountActions.resetState());
    };
  }, [dispatch]);

  const handleNameChange = (e) => {
    dispatch(createAccountActions.setName(e.target.value));
  }
  const handleEmailChange = (e) => {
    dispatch(createAccountActions.setEmail(e.target.value));
  }
  const handlePasswordChange = (e) => {
    dispatch(createAccountActions.setPassword(e.target.value));
  }
  const handleConfirmPasswordChange = (e) => {
    dispatch(createAccountActions.setConfirmPassword(e.target.value));
  }
  const handleCheck = (e) => {
    dispatch(createAccountActions.setAgree(e.target.checked));
  }
  const onRegister = () => {
    dispatch(userCreateAccount());
  };

  return (
    <div className="flex flex-row flex-grow-1
                    justify-content-center 
                    align-items-center 
                    bg-gradient-signup">
      {/* Wave Image */}
      <div className="register-wave-container">
        <img src={Wave_1_2000} alt="Wave Background" />
      </div>
      <div class="register-parent">
        <div className="createAccount-box
                      flex flex-column 
                      align-items-center
                      h-auto w-25rem
                      p-5
                      pt-4
                      pb-2
                      px-5
                      border-round-lg 
                      rounded-2xl 
                      border-1 
                      shadow-lg">
          <div
            className="text-2xl font-semibold"
          >
            Create Your Account
          </div>
          <div class="register-error-message text-base flex flex-row justify-content-center align-items-center">
            {registerErrorMessage}
          </div>
          <div className="flex flex-column w-full mb-4 gap-1">
            <label className="text-sm font-medium" htmlFor="name">
              What's your name?
            </label>
            <InputText
              id="name"
              className="register-input border-round-md py-2 px-3 fix-input-webkit-color"
              aria-describedby="name-help"
              placeholder="Enter your full name"
              onChange={handleNameChange} />
            <small id="name-help" class="register-input-message text-sm">
              {nameErrorMessage}
            </small>
          </div>

          <div className="flex flex-column w-full mb-4 gap-1">
            <label className="text-sm font-medium" htmlFor="email">
              Email address
            </label>
            <InputText
              id="email"
              type="email"
              className="register-input border-round-md py-2 px-3 fix-input-webkit-color"
              aria-describedby="email-help"
              placeholder="Enter a valid email address"
              onChange={handleEmailChange} />
            <small id="email-help" class="register-input-message text-sm">
              {emailErrorMessage}
            </small>
          </div>

          <div className="flex flex-column w-full mb-4 gap-1">
            <label className="text-sm font-medium" htmlFor="password">
              Create a password
            </label>
            <InputText
              id="password"
              type="password"
              className="register-input border-round-md py-2 px-3"
              aria-describedby="password-help"
              placeholder="Enter at least 8 characters"
              onChange={handlePasswordChange} />
            <small id="password-help" class="register-input-message text-sm">
              {passwordErrorMessage}
            </small>
          </div>

          <div className="flex flex-column w-full mb-4 gap-1">
            <label className="text-sm font-medium" htmlFor="confirm-password">
              Confirm your password
            </label>
            <InputText
              id="confirm-password"
              type="password"
              className="register-input border-round-md py-2 px-3"
              aria-describedby="confirm-password-help"
              placeholder="Retype your password"
              onChange={handleConfirmPasswordChange} />
            <small id="confirm-password-help" class="register-input-message text-sm">
              {confirmPasswordErrorMessage}
            </small>
          </div>

          <div className="w-full mb-4 flex flex-row align-items-center">
            <input id="agree" type="checkbox" className="register-chk mr-2 mt-0" onChange={handleCheck} />
            <label htmlFor="agree" className="text-white agree-text">
              I agree to Terms & Conditions and Privacy Policy
            </label>
          </div>

          <Button
            className="btn-horizontal-gradient 
                       w-full 
                       py-2
                       mb-1
                       border-round-2xl 
                       text-base
                       align-items-center
                       justify-content-center
                       gap-2"
            loading={isCreateOngoing}
            onClick={onRegister}>
            {isCreateOngoing ? "Creating account..." : "Create Your Account"}
          </Button>
          <div class="h-1rem"></div>
        </div>
      </div>
    </div>
  );
};

export default CreateAccountComp;
